import React, { useState, useEffect } from 'react'
import { getIdData } from '../../../lib/taskmanageview'
import { useNavigate, useParams } from 'react-router-dom'

export default function TaskManageDetail() {
  const [taskDetailInfo, setTaskDetailInfo] = useState()
  const navigate = useNavigate()
  let { slug } = useParams()

  async function GetData() {
    const info = await getIdData(slug)
    setTaskDetailInfo(info)
    console.log('info', info)
  }

  useEffect(() => {
    GetData()
  }, [])
  return (
    <div className='col-12'>
      <div className='tak-instruct-group'>
        <div className='row'>
          <div className='col-md-12'>
            <div className='settings-widget'>
              <div className='settings-inner-blk p-0'>
                <div className='sell-course-head comman-space'>
                  <h3>Item Detail</h3>
                  <p>
                    Order Dashboard is a quick overview of all current orders.
                  </p>
                </div>
              </div>
            </div>
            <div className='settings-widget'>
              <div className='settings-inner-blk p-0'>
                <div className='checkout-form personal-address add-course-info'>
                  <div className='personal-info-head'>
                    <h4>Item Details</h4>
                    <p className='mb-5'> </p>
                  </div>
                  <form action='#'>
                    <div className='row'>
                      <div className='col-lg-6'>
                        <div className='form-group'>
                          <label className='form-control-label'>
                            Student First Name
                          </label>
                          <p>
                            {taskDetailInfo
                              ? taskDetailInfo[0].studentname
                              : ''}
                          </p>
                        </div>
                      </div>
                      <div className='col-lg-6'>
                        <div className='form-group'>
                          <label className='form-control-label'>
                            Student First Name
                          </label>
                          <p>
                            {taskDetailInfo
                              ? taskDetailInfo[0].studentsurname
                              : ''}
                          </p>
                        </div>
                      </div>
                      <div className='col-lg-6'>
                        <div className='form-group'>
                          <label className='form-control-label'>Topic</label>
                          <p>
                            {taskDetailInfo ? taskDetailInfo[0].subject : ''}
                          </p>
                        </div>
                      </div>
                      <div className='col-lg-6'>
                        <div className='form-group'>
                          <label className='form-control-label'>Status</label>
                          <p>
                            {taskDetailInfo ? (
                              taskDetailInfo[0].status ? (
                                <span className='badge info-low'>Opened</span>
                              ) : (
                                <span className='badge info-high'>Closed</span>
                              )
                            ) : (
                              ''
                            )}
                          </p>
                        </div>
                      </div>
                      <div className='col-lg-12'>
                        <div className='form-group'>
                          <label className='form-control-label'>Desc</label>
                          <p>{taskDetailInfo ? taskDetailInfo[0].desc : ''}</p>
                        </div>
                      </div>
                      <div className='col-lg-12'>
                        <div className='form-group'>
                          <label className='form-control-label'>Answer</label>
                          <p>
                            {taskDetailInfo ? taskDetailInfo[0].answer : ''}
                          </p>
                        </div>
                      </div>
                      <div className='update-profile'>
                        <button
                          type='button'
                          className='btn btn-primary'
                          onClick={() => navigate(`/admin/admin-taskmanage`)}
                        >
                          Agenda
                        </button>
                      </div>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
